module.exports = __webpack_public_path__ + "static/profilepic_jd-f18f987a192f52a49136032643e097af.png";